var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLedgerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2977_2266",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2977_2266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3346 11.2498C13.6957 11.2498 13.9943 11.1318 14.2304 10.8957C14.4666 10.6595 14.5846 10.3609 14.5846 9.99982C14.5846 9.63871 14.4666 9.3401 14.2304 9.10398C13.9943 8.86787 13.6957 8.74982 13.3346 8.74982C12.9735 8.74982 12.6749 8.86787 12.4388 9.10398C12.2027 9.3401 12.0846 9.63871 12.0846 9.99982C12.0846 10.3609 12.2027 10.6595 12.4388 10.8957C12.6749 11.1318 12.9735 11.2498 13.3346 11.2498ZM11.0911 13.7498C10.6701 13.7498 10.3138 13.604 10.0221 13.3123C9.73047 13.0206 9.58464 12.6643 9.58464 12.2434V7.75626C9.58464 7.33531 9.73047 6.979 10.0221 6.68734C10.3138 6.39567 10.6701 6.24984 11.0911 6.24984H16.4115C16.8325 6.24984 17.1888 6.39567 17.4804 6.68734C17.7721 6.979 17.9179 7.33531 17.9179 7.75626V12.2434C17.9179 12.6643 17.7721 13.0206 17.4804 13.3123C17.1888 13.604 16.8325 13.7498 16.4115 13.7498H11.0911ZM4.42439 17.0831C4.00344 17.0831 3.64714 16.9373 3.35547 16.6456C3.0638 16.354 2.91797 15.9977 2.91797 15.5767V4.42292C2.91797 4.00198 3.0638 3.64567 3.35547 3.354C3.64714 3.06234 4.00344 2.9165 4.42439 2.9165H15.5782C15.9991 2.9165 16.3554 3.06234 16.6471 3.354C16.9388 3.64567 17.0846 4.00198 17.0846 4.42292V4.99988H11.0911C10.2652 4.99988 9.59934 5.25281 9.09347 5.75867C8.58761 6.26455 8.33468 6.93041 8.33468 7.75626V12.2434C8.33468 13.0692 8.58761 13.7351 9.09347 14.241C9.59934 14.7468 10.2652 14.9998 11.0911 14.9998H17.0846V15.5767C17.0846 15.9977 16.9388 16.354 16.6471 16.6456C16.3554 16.9373 15.9991 17.0831 15.5782 17.0831H4.42439Z",
    fill: "#9B9B9B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLedgerIcon);
export default __webpack_public_path__ + "static/media/ledger_icon.28796a106b2204a8406db135d54832a2.svg";
export { ForwardRef as ReactComponent };